export function IconUnlocked(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 15.313 20.842"
            {...props}
        >
            <defs>
                <clipPath id="clip_icon_unlocked">
                    <path d="M0 0H15.313V20.842H0z" />
                </clipPath>
            </defs>
            <g clipPath="url(#clip_icon_unlocked)">
                <path d="M13.285 5.629a5.629 5.629 0 10-11.258 0v4.495h2.489l.057-4.495a3.083 3.083 0 016.166 0v.915h2.546z" />
                <path d="M13.756 9.661H1.557A1.557 1.557 0 000 11.218v8.066a1.558 1.558 0 001.557 1.558h12.2a1.558 1.558 0 001.556-1.558v-8.066a1.557 1.557 0 00-1.556-1.557m-5.428 5.8v2.225H6.984v-2.23a1.406 1.406 0 111.344 0" />
            </g>
        </svg>
    );
}
